import {
  View,
  Text,
  SafeAreaView,
  StyleSheet,
  Platform,
  StatusBar,
  Animated,
  TouchableOpacity,
} from "react-native";
import React, { useEffect } from "react";
import { lightBlue } from "../../colors";
import HeaderProfileIcon from "./HeaderProfileIcon";
import ASQ from "../../assets/svg/ASQ";
import Notification from "./Notification";
import BackIcon from "../../assets/svg/BackIcon";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useRef } from "react";
import { useNavigation } from "@react-navigation/native";
import { hideBackButton } from "../../redux/header/headerAction";
let currentBackgroundColor = lightBlue;
export default function Header(props) {
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const header = useSelector((store) => store.header);
  const main = useSelector((store) => store.main);
  let backgroundColorAnimation = new Animated.Value(0);

  let backgroundColorInterpolator = backgroundColorAnimation.interpolate({
    inputRange: [0, 100],
    outputRange: [currentBackgroundColor, header.background],
  });

  useEffect(() => {
    backgroundColorInterpolator = backgroundColorAnimation.interpolate({
      inputRange: [0, 100],
      outputRange: [currentBackgroundColor, header.background],
    });
    Animated.timing(backgroundColorAnimation, {
      toValue: 100,
      duration: 500,
      useNativeDriver: false,
    }).start();
    setTimeout(() => {
      currentBackgroundColor = header.background;
    }, 600);
  }, [header]);

  return (
    <Animated.View style={{ backgroundColor: backgroundColorInterpolator }}>
      <SafeAreaView style={[styles.container]}>
        <View
          style={{
            flex: 1,
            alignItems: "center",
            padding: 10,
            flexDirection: "row",
            justifyContent: "center",
           
          }}
        >
          {header.backButtonShown && (
            <TouchableOpacity
              style={{
                marginHorizontal: 10,
                transform: [{ rotate: main.rtl ? "0deg" : "180deg" }],
              }}
              onPress={() => {
                header.backFunction();
                dispatch(hideBackButton());
              }}
            >
              <BackIcon />
            </TouchableOpacity>
          )}
          <HeaderProfileIcon notOpenDrawer={props.notOpenDrawer} />
        </View>

        <View style={{ flex: 1, alignItems: "center" }}>
          <ASQ />
        </View>

        <View
          style={{
            flex: 1,
            alignItems: "flex-end",
            padding: 10,
       
          }}
        >
          <View>
            <Notification />
          </View>
        </View>
      </SafeAreaView>
    </Animated.View>
  );
}

Header.defaultProps = {
  backgroundColor: lightBlue,
};

const styles = StyleSheet.create({
  container: {
    width: "100%",
    paddingTop: Platform.OS === "android" ? StatusBar.currentHeight : 0,

    display: "flex",
    flexDirection: "row",
  
    paddingBottom: 0,
  },
});
